export const REWARD_CONSUME_START = 'REWARD_CONSUME_START';
export const REWARD_CONSUME_SUCCESS = 'REWARD_CONSUME_SUCCESS';
export const REWARD_CONSUME_FAIL = 'REWARD_CONSUME_FAIL';
export const REWARD_CONSUME_RESET = 'REWARD_CONSUME_RESET';
